import React from 'react'
import PropTypes from 'prop-types'

import Container from '@/component/Primitive/Container'

import retrieveAndProcessDataForPage from '@/lib/data-for-page-processor-and-retriever'
import createRenderReleaseQuery from '@/query/release/render-release'

import Surround from '@/component/Primitive/Surround'
import ResponsiveSpacer from '@/component/Primitive/ResponsiveSpacer'
import Release from '@/component/BBFC/Release/Release'

const ReleasePage = ({ release, user, pageData }) => {
  return (
    <>
      <ResponsiveSpacer />
      <Container center size="huge" gutter>
        <Surround rounded shadow wide>
          <Release {...release} />
        </Surround>
      </Container>
    </>
  )
}

ReleasePage.propTypes = {
  release: PropTypes.object,
  user: PropTypes.object,
  pageData: PropTypes.object
}

ReleasePage.getInitialProps = async (context) => {
  const query = createRenderReleaseQuery()
  const data = await retrieveAndProcessDataForPage(context, query)
  if (data.error) return data

  const release = data && data.response && data.response.resource
  if (release.releaseType === 'Asset') {
    return {
      error: {
        statusCode: 404,
        message: 'Not found'
      }
    }
  }
  const url = data && data.vars && data.vars.url
  const pageData = { url }
  return { ...data.response, release, pageData }
}

export default ReleasePage
